import React, { useEffect, useState } from "react";
import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import { toast } from "react-toastify";
import {
  createDesignationApi,
  updateDesignationApi
} from "../../../apiServices/designation.services";
import { getDepartmentsApi } from "../../../apiServices/department.services";

const DesignationForm = ({ mode, selected, onSuccess }) => {
  const [departments, setDepartments] = useState([]);

  const [formData, setFormData] = useState({
    departmentId: "",
    title: "",
    level: "junior"
  });

  useEffect(() => {
    getDepartmentsApi().then(res => {
      setDepartments(res?.data?.data || []);
    });
  }, []);

  useEffect(() => {
    if (mode === "edit" && selected) {
      setFormData({
        departmentId: selected.departmentId?._id || "",
        title: selected.title,
        level: selected.level
      });
    }
  }, [mode, selected]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (mode === "edit") {
        await updateDesignationApi(selected._id, formData);
        toast.success("Updated");
      } else {
        await createDesignationApi(formData);
        toast.success("Created");
      }

      onSuccess();

    } catch (err) {
      toast.error(err?.error || "Failed");
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup>
        <Label>Department</Label>
        <Input
          type="select"
          value={formData.departmentId}
          onChange={(e) =>
            setFormData({ ...formData, departmentId: e.target.value })
          }
        >
          <option value="">Select</option>
          {departments.map(d => (
            <option key={d._id} value={d._id}>
              {d.name}
            </option>
          ))}
        </Input>
      </FormGroup>

      <FormGroup>
        <Label>Title</Label>
        <Input
          value={formData.title}
          onChange={(e) =>
            setFormData({ ...formData, title: e.target.value })
          }
        />
      </FormGroup>

      <FormGroup>
        <Label>Level</Label>
        <Input
          type="select"
          value={formData.level}
          onChange={(e) =>
            setFormData({ ...formData, level: e.target.value })
          }
        >
          <option value="junior">Junior</option>
          <option value="senior">Senior</option>
          <option value="manager">Manager</option>
          <option value="director">Director</option>
        </Input>
      </FormGroup>

      <div className="text-end">
        <Button color="primary">Save</Button>
      </div>
    </Form>
  );
};

export default DesignationForm;